var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13281 16.4968V2.95454C1.13935 2.46957 1.33487 2.00631 1.67782 1.66336C2.02078 1.3204 2.48405 1.12485 2.96902 1.11831H13.6039C13.6747 1.11663 13.7451 1.12934 13.8108 1.15566C13.8765 1.18198 13.9362 1.22137 13.9863 1.27144C14.0364 1.32151 14.0758 1.38122 14.1021 1.44696C14.1284 1.51269 14.1411 1.58309 14.1394 1.65388V17.9504",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88281 4.79102H10.468",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22266 12.2119H13.9286",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22266 15.043H13.9286",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50781 17.874H14.2138",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50923 15.0428C2.33672 15.0612 2.16223 15.0434 1.99701 14.9905C1.83178 14.9376 1.67946 14.8507 1.54978 14.7354C1.42011 14.6201 1.31594 14.479 1.244 14.3212C1.17207 14.1633 1.13396 13.9921 1.13207 13.8186V13.5891C1.11361 13.4166 1.13139 13.2421 1.18432 13.0769C1.23726 12.9117 1.32417 12.7593 1.43943 12.6296C1.5547 12.5 1.69576 12.3958 1.85364 12.3239C2.01153 12.2519 2.18272 12.2138 2.35621 12.2119H2.50923",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50923 17.8738C2.33672 17.8923 2.16223 17.8745 1.99701 17.8215C1.83178 17.7686 1.67946 17.6817 1.54978 17.5665C1.42011 17.4512 1.31594 17.3101 1.244 17.1522C1.17207 16.9943 1.13396 16.8232 1.13207 16.6497V16.4201C1.11361 16.2476 1.13139 16.0732 1.18432 15.9079C1.23726 15.7427 1.32417 15.5904 1.43943 15.4607C1.5547 15.331 1.69576 15.2269 1.85364 15.1549C2.01153 15.083 2.18272 15.0449 2.35621 15.043H2.50923",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeicon);
export default __webpack_public_path__ + "static/media/recipeicon.92b963abea49fd86eaf7d0cf6353b3b5.svg";
export { ForwardRef as ReactComponent };